import Icon from "./IconBase.js";
const FacultiesActiveIcon = (props) => {
  return (
    <Icon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 20.9937V18.9938C20 17.933 19.5786 16.9157 18.8284 16.1656C18.0783 15.4155 17.0609 14.9941 16 14.9941H8C6.93913 14.9941 5.92172 15.4155 5.17157 16.1656C4.42143 16.9157 4 17.933 4 18.9938V20.9937"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 10.9954C14.2091 10.9954 16 9.20473 16 6.99577C16 4.78681 14.2091 2.99609 12 2.99609C9.79086 2.99609 8 4.78681 8 6.99577C8 9.20473 9.79086 10.9954 12 10.9954Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default FacultiesActiveIcon;
